<template>
  <div
    :style="cardWrapStyle"
    class="advance-imgTxt-four"
    ref="cardWrap"
    @click="$emit('click')"
  >
    <div
      v-if="layout === 'top-image-bottom-text'"
      class="endwise"
    >
      <image-wrapper
        :style="{ height: imageHeight + 'px' }"
        :cardData="cardData"
        :imageConfig="imageConfig"
      ></image-wrapper>
      <text-content
        :cardStructure="cardStructure"
        :cardData="cardData"
        :textConfig="textConfig"
        :textAlign="textConfig.align"
      ></text-content>
    </div>
    <div
      v-if="layout === 'top-text-bottom-image'"
      class="endwise"
    >
      <text-content
        :cardStructure="cardStructure"
        :cardData="cardData"
        :textConfig="textConfig"
        :textAlign="textConfig.align"
      ></text-content>
      <image-wrapper
        :style="{ height: imageHeight + 'px' }"
        :cardData="cardData"
        :imageConfig="imageConfig"
      ></image-wrapper>
    </div>
    <div
      v-if="layout === 'left-image-right-text'"
      class="flex"
    >
      <image-wrapper
        :style="{ width: imageConfig.width + 'px', height: imageHeight + 'px' }"
        :cardData="cardData"
        :imageConfig="imageConfig"
      ></image-wrapper>
      <text-content
        :cardStructure="cardStructure" :cardData="cardData"
        :style="`width: calc(100% - ${imageConfig.width}px)`"
        :textConfig="textConfig"
        :textAlign="textConfig.align"
      ></text-content>
    </div>
    <div
      v-if="layout === 'left-text-right-image'"
      class="flex"
    >
      <text-content
        :cardStructure="cardStructure"
        :cardData="cardData"
        :style="`width: calc(100% - ${imageConfig.width}px)`"
        :textConfig="textConfig"
        :textAlign="textConfig.align"
      ></text-content>
      <image-wrapper
        :style="{ width: imageConfig.width + 'px', height: imageHeight + 'px' }"
        :cardData="cardData"
        :imageConfig="imageConfig"
      ></image-wrapper>
    </div>
    <div
      v-if="layout === 'image-full-cover'"
      class="card-full-cover"
    >
      <image-wrapper
        :style="{ height: fullCoverImageHeight + 'px' }"
        :card-data="cardData"
        :image-config="imageConfig"
      ></image-wrapper>
      <text-content
        class="card-text-full-cover"
        :cardStructure="cardStructure"
        :cardData="cardData"
        :style="textPosition"
        :textConfig="textConfig"
        :textAlign="textConfig.align"
      ></text-content>
    </div>
  </div>
</template>

<script>
import TextContent from './TextContent.vue';
import ImageWrapper from './ImageWrapper.vue';
import { arrToPx, transfCssUtil } from '../../utils/index'
export default {
  components: {
    TextContent,
    ImageWrapper
  },
  props: {
    cardData: {
      type: Object,
      default: () => ({})
    },
    cardConfig: {
      type: Object,
      default: () => ({})
    },
    imageConfig: {
      type: Object,
      default: () => ({})
    },
    textConfig: {
      type: Object,
      default: () => ({})
    },
    layout: {
      type: String,
      default: 'top-image-bottom-text',
      validator: (value) => {
        return [
          'top-image-bottom-text',
          'top-text-bottom-image',
          'left-image-right-text',
          'left-text-right-image',
          'image-full-cover'
        ].includes(value)
      }
    }
  },
  data () {
    return {
      imageHeight: 'auto',
      arrToPx
    }
  },
  computed: {
    fullCoverImageHeight () {
      const cardHeight = this.cardConfig.cardHeight
      const imageHeight = this.imageHeight
      return cardHeight ? cardHeight : imageHeight
    },
    cardWrapStyle () {
      const cardConfig = this.cardConfig
      return {
        backgroundColor: cardConfig.bgColor,
        boxShadow: cardConfig.boxShadow,
        borderRadius: arrToPx(cardConfig.borderRadius),
        padding: arrToPx(cardConfig.padding)
      }
    },
    textPosition () {
      const obj = {}
      const { placement, heightNum = 30, width } = this.textConfig;
      const [placementInfo, x, y] = placement.split('|')
      const placementArr = placementInfo.split('-')
      obj[placementArr[0]] = arrToPx([x]);
      obj[placementArr[1]] = arrToPx([y]);
      // obj['height'] = heightNum + 'px';
      obj['width'] = width ? width.includes('%') ? width : width + 'px' : '';
      return obj
    },
    cardStructure () {
      const layout = this.layout
      return layout === 'left-image-right-text' || layout === 'left-text-right-image' ? 'left-right' : layout === 'image-full-cover' ? 'full-cover' : 'up-down'
    },
  },
  methods: {
    getImageHeight () {
      this.$nextTick(() => {
        const { ratio, width }= this.imageConfig
        const [widthRatio, heightRatio] = (ratio || '1:1').split(':').map(Number);
        const cardWrap = this.$refs.cardWrap;
        if (cardWrap) {
          const cardWrapWidth = cardWrap.offsetWidth;
          const actualWidth = this.cardStructure === 'left-right' ? width : cardWrapWidth;
          this.imageHeight = (actualWidth * heightRatio) / widthRatio;
        }
      })
    }
  },
  created () {
    this.getImageHeight()
  },

  mounted() {
    const element = this.$refs.cardWrap;
    const resizeObserver = new ResizeObserver(entries => {
      this.getImageHeight()
      // for (let entry of entries) {
      //   console.log('Element size changed:', entry.contentRect);
      //   // 这里你可以执行其他逻辑，例如重新计算布局或者重新渲染组件等
      // }
    });
    resizeObserver.observe(element);
  },
  beforeDestroy() {
    const cardWrap = this.$refs.cardWrap;
    if (cardWrap) {
      const resizeObserver = cardWrap?._observer; // 获取到ResizeObserver实例
      if (resizeObserver) {
        resizeObserver.unobserve(cardWrap); // 停止观察
        resizeObserver.disconnect(); // 断开连接
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.advance-imgTxt-four {
  overflow: hidden;
  height 100%
}
.image-wrapper {
  overflow: hidden;
}
.card-full-cover {
  position: relative;
  .card-text-full-cover {
    position: absolute;
  }
}
</style>
